module.exports = __webpack_public_path__ + "static/media/(V)_MG_6242_-_Joias_Contenporaneas.d7ea502c.jpg";